import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { UtilsService } from "../../../auth/service/utils.service";
import recruitmentMenu from "../recruitment.menu";
import { RouterModule } from "@angular/router";
import { ContentHeaderModule } from "../../../layout/components/content-header/content-header.module";
import { TranslateModule } from "@ngx-translate/core";
import { Ng2FlatpickrModule } from "ng2-flatpickr";
import { NgxDatatableModule } from "@swimlane/ngx-datatable";
import { ExtendedModule } from "@angular/flex-layout";
import { CoreCommonModule } from "../../../../@core/common.module";
import { NgSelectModule } from "@ng-select/ng-select";
import { CreateRequestComponent } from "./pages/create/create-request.component";
import { RequestDetailComponent } from "./pages/detail/request-detail.component";
import { EditRequestComponent } from "./pages/edit/edit-request.component";
import { RequestsListComponent } from "./pages/list/requests-list.component";
import requestsRoutes from "./requests.routes";
import { locale as requestsIt } from "./i18n/requests.lang-it";
import { LayoutModule } from "../../../layout/layout.module";
import { CoreCardModule } from "../../../../@core/components/core-card/core-card.module";
import { AngularEditorModule } from "@kolkov/angular-editor";
import { NgbDropdownModule, NgbTimepickerModule, NgbTooltipModule } from "@ng-bootstrap/ng-bootstrap";
import { BreadcrumbModule } from "../../../layout/components/content-header/breadcrumb/breadcrumb.module";
import { DragDropModule } from "@angular/cdk/drag-drop";
import { CustomerModule } from "../../customer/customer.module";

@NgModule({
  declarations: [CreateRequestComponent, RequestDetailComponent, EditRequestComponent, RequestsListComponent],
  imports: [
    RouterModule.forChild(requestsRoutes),
    CommonModule,
    NgSelectModule,
    CoreCommonModule,
    ContentHeaderModule,
    TranslateModule,
    ExtendedModule,
    Ng2FlatpickrModule,
    NgxDatatableModule,
    LayoutModule,
    CoreCardModule,
    AngularEditorModule,
    NgbTooltipModule,
    BreadcrumbModule,
    DragDropModule,
    NgbTimepickerModule,
    NgbDropdownModule,
    CustomerModule
  ]
})
export class RequestsModule {
  constructor(private _utils: UtilsService) {
    this._utils.initModule("requests", requestsIt, recruitmentMenu, []);
  }
}
